import { render, staticRenderFns } from "./SurveyQuestionReadonly.vue?vue&type=template&id=6f735492&"
import script from "./SurveyQuestionReadonly.vue?vue&type=script&lang=ts&"
export * from "./SurveyQuestionReadonly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports